import useTestId from '@ori/testid-generator';
import { PAGINATION } from "./constants";
import { InfoText, LinearProgress, PaginationLoadMoreButton, Root } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/** Component that displays pagination info. Displays info text, pagination progress value in MUI `LinearProgress` and button for loading another page. */
export var Pagination = function Pagination(_ref) {
  var button = _ref.button,
    className = _ref.className,
    infoText = _ref.infoText,
    progress = _ref.progress;
  var label = button.label,
    onClick = button.onClick,
    disabled = button.disabled,
    loading = button.loading,
    visible = button.visible;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  return /*#__PURE__*/_jsxs(Root, {
    className: className,
    "data-testid": getTestId(PAGINATION),
    children: [/*#__PURE__*/_jsx(InfoText, {
      children: infoText
    }), /*#__PURE__*/_jsx(LinearProgress, {
      color: "secondary",
      isButtonVisible: visible,
      value: progress,
      variant: "determinate"
    }), visible ? /*#__PURE__*/_jsx(PaginationLoadMoreButton, {
      variant: "outlined",
      disabled: disabled,
      loading: loading,
      size: "large",
      onClick: onClick,
      children: label
    }) : null]
  });
};
//# sourceMappingURL=Pagination.js.map